module.exports = __webpack_public_path__ + "img/logo-white.9be92cb0.png";